module.exports = __webpack_public_path__ + "img/aboutUs-header-img02_en.01fdb0ac.png";